import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import DataTable, { TableColumn } from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import "../../style/customcssfile.css";
import "../../style/finishorder.css";
import VectorMap from "./components/VectorMap";
import { LocationData } from "./types/LocationData";
import MapplsVectorMap from "../Mapple";
import { useRef } from "react";
import { Clinic } from "./interface/Clinic";
import { apiAxios } from "../../utils/apiAxios";
const API_BASE = process.env.REACT_APP_API_BASE_URL;



const ClinicDetails: React.FC = () => {
  const [clinic, setClinic] = useState({
    name: "",
    address: "",
    contact: "",
    gst: "",
    practiceId: "",
    Latitude: "",
    Longitude: "",
    DigiPin: "",
    emailID: ""
  });

  const [clinics, setClinics] = useState<Clinic[]>([]);
  const [filteredClinics, setFilteredClinics] = useState<Clinic[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deletingClinicID, setDeletingClinicID] = useState<number | null>(null);
  const token = sessionStorage.getItem("token") || "";
  const hasReloaded = useRef(false); // ✅ correct place

  useEffect(() => {
    if (sessionStorage.getItem("clinicApproved") === "true") {
      hasReloaded.current = true;
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchClinics(); // 🔁 auto refresh
    }, 15000); // 15 seconds

    return () => clearInterval(interval);
  }, []);
  const hasShownToast = useRef(false);

useEffect(() => {
  if (clinics.length === 0) return;

  const hasApprovedClinic = clinics.some(
    (c) => c.isApprove === true
  );

  if (!hasApprovedClinic && !hasShownToast.current) {
    toast.info("Your clinic is not approved yet. Please wait for approval.");
    hasShownToast.current = true;
  }
}, [clinics]);

  // ✅ Fetch clinic list
  const fetchClinics = async () => {
    try {
      setLoading(true);

      const token = sessionStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token ? { AuthorizationData: token } : {}),
      };

      const res = await apiAxios.get(`${API_BASE}/ClinicDetails/All`, { headers });

      if (res.data.isSuccess && res.data.data) {
        const sortedClinics = res.data.data.sort(
          (a: Clinic, b: Clinic) =>
            new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
        );

        setClinics(sortedClinics);
        setFilteredClinics(sortedClinics);

        // ✅ ALWAYS sync clinics to session user
        const userData = JSON.parse(sessionStorage.getItem("user") || "{}");

        const updatedUser = {
          ...userData,
          clinicDetails: sortedClinics,
        };

        sessionStorage.setItem("user", JSON.stringify(updatedUser));
        sessionStorage.setItem("selectedClinicId", sortedClinics[0].clinicID.toString());
        sessionStorage.setItem("selectedClinic", JSON.stringify(sortedClinics[0])
            );

        // ✅ redirect only once when approved
        const hasApprovedClinic = sortedClinics.some(
          (c: Clinic) => c.isApprove === true
        );

        if (hasApprovedClinic && !hasReloaded.current) {
          hasReloaded.current = true;

          sessionStorage.setItem("clinicApproved", "true");

          window.location.reload();
        }

      }


      else {
        setClinics([]);
        setFilteredClinics([]);
      }
    } catch (error: any) {
      console.error("Error fetching clinics:", error);
      toast.error(error.response?.data?.Status || "Failed to fetch clinics.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchClinics();
  }, []);


  useEffect(() => {
    const filtered = clinics.filter(
      (c) =>
        c.clinicName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.address.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.deliveryContact.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (c.emailID || "").toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredClinics(filtered);
  }, [searchTerm, clinics]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    if (name === "name") {
      const lettersOnly = /^[A-Za-z0-9\s]*$/;
      if (!lettersOnly.test(value)) return;
    }

    if (name === "contact") {
      const numbersOnly = /^[0-9]*$/;
      if (!numbersOnly.test(value)) return;
    }

    if (name === "Latitude" || name === "Longitude") {
      setClinic({ ...clinic, [name]: value === "" ? 0 : parseFloat(value) });
      return;
    }

    setClinic({ ...clinic, [name]: value });
  };

  const saveClinic = async () => {
    if (!clinic.name || !clinic.address || !clinic.contact) {
      toast.error("Please fill all required fields");
      return false;
    }
    if (!clinic.emailID) {
      toast.error("Email is required");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(clinic.emailID)) {
      toast.error("Invalid email format");
      return false;
    }

    if (!/^[A-Za-z0-9\s]+$/.test(clinic.name)) {
      toast.error("Clinic Name can contain letters, numbers, and spaces only");
      return false;
    }

    if (!/^[0-9]{10}$/.test(clinic.contact)) {
      toast.error("Delivery Contact must be 10 digits");
      return false;
    }

    const token = sessionStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      ...(token ? { AuthorizationData: token } : {}),
    };

    const payload = {
      ClinicName: clinic.name,
      Address: clinic.address,
      DeliveryContact: clinic.contact,
      GSTNo: clinic.gst,
      PracticeID: clinic.practiceId,
      Latitude: clinic.Latitude,
      Longitude: clinic.Longitude,
      DigiPin: clinic.DigiPin,
      EmailID: clinic.emailID
    };

    try {
      let response;

      if (editMode && editId !== null) {
        response = await apiAxios.put(
          `${API_BASE}/ClinicDetails/Update/${editId}`,
          payload,
          { headers }
        );
      } else {
        response = await apiAxios.post(`${API_BASE}/ClinicDetails/Add`, payload, {
          headers,
        });
      }

      if (response.status === 200 || response.status === 201) {
        toast.success(
          editMode
            ? "Clinic updated successfully!"
            : "Clinic saved successfully!"
        );
        fetchClinics();
        resetForm();
        return true;
      } else {
        toast.error("Something went wrong! Please try again.");
        return false;
      }
    } catch (error: any) {
      console.error(error.response?.data);

      if (error.response?.status === 409) {
        toast.error("Clinic name already exists");
      } else {
        toast.error(
          error.response?.data?.status ||
          error.response?.data?.Status ||
          "API request failed"
        );
      }

      return false;
    }

  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await saveClinic();
    if (success) setSubmitted(true);
  };

  const handleAddAnother = () => {
    resetForm();
    setAddMode(true);
  };

  const handleAddAnotherSave = async () => {
    const success = await saveClinic();
    if (success) resetForm();
  };

  const resetForm = () => {
    setClinic({
      name: "",
      address: "",
      contact: "",
      gst: "",
      practiceId: "",
      Latitude: "",
      Longitude: "",
      DigiPin: "",
      emailID: ""
    });
    setSubmitted(false);
    setAddMode(false);
    setEditMode(false);

    setEditId(null);
  };

  const handleDeleteClick = (clinicID: number) => {
    setDeletingClinicID(clinicID);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (!deletingClinicID) return;

    try {
      const res = await apiAxios.post(
        `${API_BASE}/ClinicDetails/Delete/${deletingClinicID}`,
        {},
        { headers: { AuthorizationData: token } }
      );

      if (res.data.isSuccess) {
        toast.success("Clinic deleted (marked inactive) successfully!");
        fetchClinics();
      } else {
        toast.warning(res.data.status || "Unable to delete clinic.");
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.status ||
        error?.response?.data?.Status ||
        error?.response?.data?.message ||
        "Error deleting clinic";

      toast.error(message);
    } finally {
      setShowDeleteConfirm(false);
      setDeletingClinicID(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
    setDeletingClinicID(null);
  };


  const handleEdit = (clinicData: Clinic) => {
    setClinic({
      name: clinicData.clinicName || "",
      address: clinicData.address || "",
      contact: clinicData.deliveryContact || "",
      gst: clinicData.gstNo || "",
      practiceId: clinicData.practiceID || "",
      Latitude: clinicData.latitude || "",
      Longitude: clinicData.longitude || "",
      DigiPin: clinicData.DigiPin || "",
      emailID: clinicData.emailID || ""
    });
    setAddMode(true);
    setSubmitted(false);
    setEditMode(true);
    setEditId(clinicData.clinicID);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getStatusBadge = (clinic: Clinic) => {
    const active = clinic.isActive ?? false;
    const approved = clinic.isApprove ?? false;
    const rejected = clinic.isReject ?? false;

    if (!active) return <span className="badge bg-secondary">Inactive</span>;
    if (approved) return <span className="badge bg-success">Approved</span>;
    if (rejected) return <span className="badge bg-danger">Rejected</span>;
    return <span className="badge bg-warning text-white">Pending</span>;
  };

  const columns: TableColumn<Clinic>[] = [
    { name: "Clinic Name", selector: (row) => row.clinicName, sortable: true },
    {
      name: "Address", selector: (row) => row.address, sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.emailID || "-",
      sortable: true,
      center: true
    },
    { name: "GST No", center: true, selector: (row) => row.gstNo || "-", sortable: true },
    { name: "Delivery Contact", center: true, selector: (row) => row.deliveryContact, sortable: true },
    { name: "Practice ID", center: true, selector: (row) => row.practiceID || "-", sortable: true },

    {
      name: "Status", center: true, cell: (row) => getStatusBadge(row),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-2">
          {(!row.isApprove || row.isReject || !row.isActive) && (
            <button
              onClick={() => handleEdit(row)}
              className="action-btn edit"
              title="Edit"
            >
              <i className="bi bi-pencil-square  customedit-icon"></i>
            </button>
          )}

          {row.isActive && (
            <button
              onClick={() => handleDeleteClick(row.clinicID)}
              className="action-btn delete"
              title="Delete"
            >
              <i className="bi bi-trash customdelete-icon"></i>
            </button>
          )}
        </div>
      ),


      center: true
    },
  ];

  const customStyles = {
    // headRow: { style: { backgroundColor: "#3D8BFD", color: "white" } },
    headCells: { style: { fontSize: "14px", justifyContent: "center" } },
    cells: { style: { fontSize: "14px" } },
  };
  const handleMapConfirm = (data: LocationData) => {
    setClinic((prev) => ({
      ...prev,
      Latitude: data.latitude.toString(),
      Longitude: data.longitude.toString(),
      address: data.address || prev.address,
      DigiPin: data.digiPin,
    }));
  };

  return (
    <div>

      {!submitted ? (
        <motion.div
          className="premium-card mb-5"
          style={{ width: "100%", zIndex: 2 }}
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -60 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div className=" border-bottom ">
            <h6 className="text-muted lets-add-your">
              {editMode
                ? "Edit Clinic Details"
                : addMode
                  ? "Add another clinic details"
                  : "Let's add your clinic to get started"}
            </h6>
            <h6 className="the-dashboard mt-2 mb-4">Note : The dashboard will be available only after clinic approval.
            </h6>
          </div>
          <form onSubmit={handleSubmit} className="mt-3">
            <div className="row">
              <div className="col-md-7">
                <div className="row">
                  <div className="col-md-4 mb-4">
                   <label className="form-label">
  Clinic Name <span className="text-danger">*</span>
</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={clinic.name}
                      onChange={handleChange}
                      placeholder="Clinic Name"
                         title={clinic.name}  
                    />
                  </div>

                  <div className="col-md-4 mb-4">
                    <label className="form-label">Delivery Contact <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="contact"
                      maxLength={10}
                      value={clinic.contact}
                      onChange={handleChange}
                      placeholder="Delivery Contact"
                    />
                  </div>
              
                <div className="col-md-4 mb-4">
                  <label className="form-label">Email  <span className="text-danger">*</span></label>
                  <input
                    type="email"
                    className="form-control"
                    name="emailID"
                    value={clinic.emailID}
                    onChange={handleChange}
                    placeholder="Enter Email"
                       title={clinic.emailID}  
                  />
                </div>
  </div>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <label className="form-label">GST No. (Optional)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="gst"
                      maxLength={15}
                      value={clinic.gst}
                      onChange={handleChange}
                      placeholder="GST No"
                    />
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label">Practice ID (Optional)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="practiceId"
                      value={clinic.practiceId}
                      onChange={handleChange}
                      placeholder="Practice ID"
                    />
                  </div>
                </div>



                <div className="row">
                  <div className="col-md-6 mb-4">
                    <label className="form-label">Latitude <span className="text-danger">*</span></label>
                    <input
                      readOnly
                      type="text"
                      className="form-control"
                      name="Latitude"
                      maxLength={15}
                      value={clinic.Latitude}
                      onChange={handleChange}
                      placeholder="Latitude"
                    />
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label">Longitude <span className="text-danger">*</span></label>
                    <input
                      readOnly
                      type="text"
                      className="form-control"
                      name="Longitude"
                      value={clinic.Longitude}
                      onChange={handleChange}
                      placeholder="Longitude"
                    />
                  </div>
                </div>

                <div className="mb-4 col-md-12">
                  <label className="form-label">Address <span className="text-danger">*</span></label>
                  <textarea
                    className="form-control"
                    name="address" style={{ height: "110px" }}
                    value={clinic.address}
                    onChange={handleChange}
                    placeholder="Enter clinic address"
                  />
                </div>
                <div className="d-flex justify-content-start mt-3 pb-3">
                  {editMode ? (
                    <button type="submit" className="btn btn-primary">
                      Update Clinic
                    </button>
                  ) : addMode ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleAddAnotherSave}
                    >
                      Add another Clinic
                    </button>
                  ) : (
                    <>
                      <button type="submit" className="btn py-2 px-3 btn-primary">
                        Continue
                      </button>
                      <button
                        type="button"
                        className="btn py-2 px-3 btn-secondary mx-2"
                        onClick={handleAddAnother}
                      >
                        Add another Clinic
                      </button>
                    </>
                  )}
                </div>
              </div>
              <div className="col-md-5">
                <p className="custommt"></p>
                <VectorMap provider="google" onConfirm={handleMapConfirm} />
                {/* <MapplsVectorMap
                  onConfirm={handleMapConfirm}
                />  */}
              </div>
            </div>
          </form>
        </motion.div>
      ) : (
        <div className="thankyou-wrapper d-flex justify-content-center  mt-5 pt-3">
          <motion.div
            className="thankyou-card text-center p-5 border rounded shadow-lg bg-white"
            initial={{ opacity: 0, y: 60, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -60 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <motion.div
              className="check-icon mx-auto mb-4"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5, ease: "backOut", delay: 0.2 }}
            >
              <i className="bi bi-check2-circle customcheck-icon2"></i>
            </motion.div>

            <h3 className="fw-bold mb-2 gradient-text">Thank you for joining!</h3>
            <p className="mt-2 text-muted">
              Our team is verifying your account. We’ll email you within 24 hours once everything is ready!
            </p>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="btn btn-primary mt-4"
              onClick={handleAddAnother}
            >
              + Add Another Clinic
            </motion.button>
          </motion.div>
        </div>
      )}


      {showDeleteConfirm && (
        <>
          <div className="modal-backdrop fade show"></div>

          <div
            className="modal fade show"
            tabIndex={-1}
            style={{ display: "block" }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title ">Delete Clinic</h5>
                  {/* <button
              type="button"
              className="btn-close custom-close-btn"

            ></button> */}
                  <button type="button" onClick={cancelDelete} className="btn-close custom-close-btn" data-bs-dismiss="modal" aria-label="Close"><i className="bi bi-x customcross"></i></button>
                </div>

                <div className="modal-body">
                  <div className="text-center">
                    Are you sure you want to delete this clinic?
                    <br />
                    <strong>This action cannot be undone.</strong>
                  </div>
                </div>

                <div className="d-flex justify-content-center pb-3 gap-2">
                  <button onClick={confirmDelete} className="btn-primary btn">Delete</button>
                  <button onClick={cancelDelete} className="btn-secondary btn">Cancel</button>

                </div>

              </div>
            </div>
          </div>
        </>
      )}


      {!submitted && (
        <div className="premium-card p-4 mt-5">
          <div className="row mb-3">
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredClinics}
            progressPending={loading}
            pagination
            highlightOnHover
            noDataComponent="No clinics found."
            customStyles={customStyles}
            className="admin-delivery-table"
          // className="dentisttable-custom"
          />
        </div>
      )}

    </div>
  );
};

export default ClinicDetails;
